import React from "react";
import ExportForm from "../../Form/ExportForm";
type Props = {};
export const EditForm: React.FC<Props> = ({}) => {
  return <ExportForm />;
};
export default EditForm;
